var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWaiting = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161.359,
    height: 120.69,
    viewBox: "0 0 161.359 120.69",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5626",
    "data-name": "Group 5626",
    transform: "translate(-128.555 -427.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5625",
    "data-name": "Group 5625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4409",
    "data-name": "Group 4409",
    transform: "translate(-2.743 51.987)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3576",
    "data-name": "Group 3576",
    transform: "translate(133.807 375.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1769",
    "data-name": "Path 1769",
    d: "M131.194,60.871a42.26,42.26,0,0,0,4.09-19.578C134.591,19.09,116.09.657,93.792.013,81.825-.332,71.685,6.328,61.635,11.839a53.072,53.072,0,0,1-24,6.8c-7.691.2-14.077-1.755-21.632.858C2.687,24.1.207,37.129,0,51.172c0,.084,0-.084,0,0C-.089,63.286,17.565,73.815,29.73,73.815l53.62,6.057C111.138,85.707,127.587,68.448,131.194,60.871Z",
    transform: "matrix(0.946, -0.326, 0.326, 0.946, 0, 44.051)",
    fill: "#f0eaff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1884",
    "data-name": "Group 1884",
    transform: "translate(7.937 16.098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1881",
    "data-name": "Group 1881",
    transform: "matrix(0.875, -0.485, 0.485, 0.875, 116.688, 84.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1882",
    "data-name": "Group 1882",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1778",
    "data-name": "Rectangle 1778",
    width: 4.233,
    height: 12.083,
    rx: 2.117,
    transform: "translate(12.083 3.781) rotate(90)",
    fill: "#6833f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2445",
    "data-name": "Rectangle 2445",
    width: 4.233,
    height: 12.083,
    rx: 2.117,
    transform: "translate(3.781 0)",
    fill: "#6833f8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_207",
    "data-name": "Ellipse 207",
    transform: "translate(0 10.095)",
    fill: "none",
    stroke: "#6833f8",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.372,
    cy: 6.372,
    rx: 6.372,
    ry: 6.372,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.372,
    cy: 6.372,
    rx: 5.372,
    ry: 5.372,
    fill: "none"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_208",
    "data-name": "Ellipse 208",
    cx: 2.549,
    cy: 2.549,
    rx: 2.549,
    ry: 2.549,
    transform: "translate(31.383)",
    fill: "#6833f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_209",
    "data-name": "Ellipse 209",
    transform: "translate(130.943 97.216)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.124,
    cy: 2.124,
    rx: 2.124,
    ry: 2.124,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.124,
    cy: 2.124,
    rx: 1.624,
    ry: 1.624,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3545",
    "data-name": "Group 3545",
    transform: "translate(37.151 23.304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3351",
    "data-name": "Group 3351",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1181",
    "data-name": "Group 1181",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M83.592,45.173a38.943,38.943,0,1,1-77.887,0C5.7,23.668,24.118,6.379,45.623,6.379S83.592,23.668,83.592,45.173Z",
    transform: "translate(-4.908 -2.76)",
    fill: "#009245"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_120",
    "data-name": "Ellipse 120",
    cx: 39.487,
    cy: 38.945,
    rx: 39.487,
    ry: 38.945,
    transform: "translate(0 0.521)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_121",
    "data-name": "Ellipse 121",
    cx: 38.945,
    cy: 38.945,
    rx: 38.945,
    ry: 38.945,
    transform: "translate(0.217 0)",
    fill: "#9fd647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M53.21,7.515A33.1,33.1,0,1,1,7.33,53.4,33.307,33.307,0,1,0,53.21,7.515Z",
    transform: "translate(3.558 3.159)",
    fill: "#009245"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M6.719,41.031A34.416,34.416,0,0,1,38.651,6.708,33.309,33.309,0,0,0,6.52,39.994a33.718,33.718,0,0,0,.621,6.427A35.074,35.074,0,0,1,6.719,41.031Z",
    transform: "translate(-0.662 -1.046)",
    fill: "#009245"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1173",
    "data-name": "Group 1173",
    transform: "translate(36.844 25.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1172",
    "data-name": "Group 1172"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1689",
    "data-name": "Rectangle 1689",
    width: 24.799,
    height: 11.693,
    fill: "#9fd647"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1174",
    "data-name": "Group 1174",
    transform: "translate(16.123 36.172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M14.4,15.794a2.109,2.109,0,0,0-.59-.093q-2.208,0-5.136,3.074c-.217.149-.385.075-.5-.23v-.323a21.051,21.051,0,0,1,3.434-4.583A17.621,17.621,0,0,1,14.4,11.621Z",
    transform: "translate(-8.173 -11.621)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1175",
    "data-name": "Group 1175",
    transform: "translate(20.88 48.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M14.752,16.325h.13c.354-.435.727-.9,1.136-1.4a13.054,13.054,0,0,1,1.354-1.4,9.253,9.253,0,0,1,1.615,1.093c.528.466,1.05.919,1.577,1.354.143.236.143.422,0,.571-.236.373-1.025,1.366-2.36,2.968a.9.9,0,0,1-.789-.3,2.574,2.574,0,0,0-.565-.441c-.323-.23-.789-.584-1.4-1.043a1.671,1.671,0,0,0-1.093-.4,18.361,18.361,0,0,1-1.969,2.534q-1.09-.782-3.4-2.186a.43.43,0,0,1,.087-.522,33.7,33.7,0,0,1,2.273-3.186A10.457,10.457,0,0,1,14.752,16.325Z",
    transform: "translate(-8.939 -13.53)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1176",
    "data-name": "Group 1176",
    transform: "translate(21.756 35.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M9.08,12.946l.6-.366a9.615,9.615,0,0,1,2.155-.869,3.657,3.657,0,0,1,3.347.963A4.95,4.95,0,0,0,17.7,13.815,5.528,5.528,0,0,0,21.643,11.8l.273-.366.869.776a29.774,29.774,0,0,1-2.565,3.254,22.945,22.945,0,0,1-3.211,2.658A5.844,5.844,0,0,1,13.943,19a4.011,4.011,0,0,1-2.428-1.149,5.955,5.955,0,0,0-1.838-1.1l-.41-.093Z",
    transform: "translate(-9.08 -11.437)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1177",
    "data-name": "Group 1177",
    transform: "translate(32.803 42.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M16.672,15.494h.13c.354-.441.727-.907,1.136-1.4a12.7,12.7,0,0,1,1.354-1.4,9.617,9.617,0,0,1,1.615,1.093c.528.466,1.049.919,1.577,1.354.143.236.143.422,0,.571q-.354.568-2.36,2.968a.9.9,0,0,1-.789-.3,2.809,2.809,0,0,0-.565-.441q-.484-.345-1.4-1.043a1.671,1.671,0,0,0-1.093-.4,18.362,18.362,0,0,1-1.969,2.534q-1.09-.782-3.4-2.18A.44.44,0,0,1,11,16.32a33.7,33.7,0,0,1,2.273-3.186A10.555,10.555,0,0,1,16.672,15.494Zm.963,8.905-.3-.043a8.422,8.422,0,0,1-1.509-1c-.627-.5-1.087-.863-1.379-1.093-.174-.174-.242-.292-.217-.354q.792-.959,2.447-2.838c.261-.174.466-.186.615-.043a11.386,11.386,0,0,1,2.881,2.142,8.367,8.367,0,0,1-1.18,1.639C18.373,23.517,17.926,24.051,17.634,24.4Z",
    transform: "translate(-10.859 -12.693)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1178",
    "data-name": "Group 1178",
    transform: "translate(34.362 29.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M11.936,17.409l-.826-.82.273-.373a9.715,9.715,0,0,0,.646-1.006,4.747,4.747,0,0,1,.826-1.056,1.541,1.541,0,0,1,1.279-.46,4.489,4.489,0,0,1,.919.161,4.1,4.1,0,0,0,.963.161,1.114,1.114,0,0,0,.826-.323,5.42,5.42,0,0,0,.894-1.6,5.182,5.182,0,0,1,.8-1.509c.3-.062.46.012.46.224a2.828,2.828,0,0,1-.186,1.056c-.093.273-.168.491-.23.646-.3.733-.627,1.447-.963,2.149a4.368,4.368,0,0,1-1.7,1.838,2.627,2.627,0,0,1-1.509.043,3.572,3.572,0,0,0-1.285-.093,1.9,1.9,0,0,0-.869.553Z",
    transform: "translate(-11.11 -10.563)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1179",
    "data-name": "Group 1179",
    transform: "translate(41.715 26.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M21.64,17.507a18.069,18.069,0,0,1-2.273,5.676,2.77,2.77,0,0,1-1.832,1.31c-.727.174-1.472.36-2.229.565q-.829.261-2.534.745c-.261,0-.422-.087-.478-.261,0-.2.186-.422.565-.658,1.167-.7,2.329-1.385,3.5-2.056a22.574,22.574,0,0,0,3.279-2.484A1.9,1.9,0,0,0,19.9,18.9a1.725,1.725,0,0,0-.615-.876,4.4,4.4,0,0,1-.826.087,2.718,2.718,0,0,1-2.36-1.093,2.123,2.123,0,0,1-.3-1.093,4.11,4.11,0,0,1,.391-1.528c.23-.466.453-.95.652-1.459s.4-1.056.571-1.639a2.419,2.419,0,0,1,1.267-1.267,2.12,2.12,0,0,1,2.316,1.18,7.372,7.372,0,0,1,.956,3.844A10.384,10.384,0,0,1,21.64,17.507Z",
    transform: "translate(-12.294 -9.997)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1180",
    "data-name": "Group 1180",
    transform: "translate(51.846 26.907)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M16.984,24.456c-.528.087-1.385.236-2.577.441-.261,0-.422-.093-.478-.267-.031-.261.155-.509.565-.739,1.136-.7,2.254-1.4,3.366-2.1a25.289,25.289,0,0,0,3.186-2.36,15.013,15.013,0,0,0,2.4-4.235l1.658-4.713c.056-.236.248-.354.565-.354a.383.383,0,0,1,.441.354,17.154,17.154,0,0,1-.745,3.8,33.3,33.3,0,0,1-3.229,8.34,3.109,3.109,0,0,1-2.316,1.441C18.86,24.182,17.916,24.313,16.984,24.456Z",
    transform: "translate(-13.925 -10.129)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4423",
    "data-name": "Group 4423",
    transform: "translate(128.496 511.431) rotate(-14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3351-2",
    "data-name": "Group 3351",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1181-2",
    "data-name": "Group 1181",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_625-2",
    "data-name": "Path 625",
    d: "M42.1,24.509a18.2,18.2,0,1,1-36.4,0c0-10.05,8.6-18.13,18.655-18.13A17.756,17.756,0,0,1,42.1,24.509Z",
    transform: "translate(-5.333 -4.688)",
    fill: "#009245"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_120-2",
    "data-name": "Ellipse 120",
    cx: 18.453,
    cy: 18.2,
    rx: 18.453,
    ry: 18.2,
    transform: "translate(0 0.244)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_121-2",
    "data-name": "Ellipse 121",
    cx: 18.2,
    cy: 18.2,
    rx: 18.2,
    ry: 18.2,
    transform: "translate(0.101)",
    fill: "#9fd647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626-2",
    "data-name": "Path 626",
    d: "M28.771,7.515A15.471,15.471,0,1,1,7.33,28.956,15.565,15.565,0,1,0,28.771,7.515Z",
    transform: "translate(-2.242 -2.527)",
    fill: "#009245"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627-2",
    "data-name": "Path 627",
    d: "M6.613,22.748A16.083,16.083,0,0,1,21.536,6.708,15.566,15.566,0,0,0,6.52,22.263a15.757,15.757,0,0,0,.29,3A16.391,16.391,0,0,1,6.613,22.748Z",
    transform: "translate(-3.783 -4.062)",
    fill: "#009245"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1173-2",
    "data-name": "Group 1173",
    transform: "translate(17.218 12.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1172-2",
    "data-name": "Group 1172"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1689-2",
    "data-name": "Rectangle 1689",
    width: 11.589,
    height: 5.464,
    fill: "#9fd647"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1174-2",
    "data-name": "Group 1174",
    transform: "translate(7.535 16.904)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_628-2",
    "data-name": "Path 628",
    d: "M11.084,13.571a.986.986,0,0,0-.276-.044,3.713,3.713,0,0,0-2.4,1.437c-.1.07-.18.035-.235-.107v-.151a9.838,9.838,0,0,1,1.6-2.142,8.235,8.235,0,0,1,1.306-.943Z",
    transform: "translate(-8.173 -11.621)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1175-2",
    "data-name": "Group 1175",
    transform: "translate(9.758 22.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_629-2",
    "data-name": "Path 629",
    d: "M11.655,14.836h.061c.165-.2.34-.421.531-.653a6.1,6.1,0,0,1,.633-.653,4.324,4.324,0,0,1,.755.511c.247.218.49.43.737.633.067.11.067.2,0,.267-.11.174-.479.638-1.1,1.387a.421.421,0,0,1-.369-.142,1.2,1.2,0,0,0-.264-.206c-.151-.107-.369-.273-.653-.488a.781.781,0,0,0-.511-.186,8.581,8.581,0,0,1-.92,1.184q-.509-.366-1.59-1.022A.2.2,0,0,1,9,15.225a15.751,15.751,0,0,1,1.062-1.489A4.887,4.887,0,0,1,11.655,14.836Z",
    transform: "translate(-8.939 -13.53)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1176-2",
    "data-name": "Group 1176",
    transform: "translate(10.167 16.37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_630-2",
    "data-name": "Path 630",
    d: "M9.08,12.142l.279-.171a4.493,4.493,0,0,1,1.007-.406,1.709,1.709,0,0,1,1.564.45,2.313,2.313,0,0,0,1.178.534,2.583,2.583,0,0,0,1.843-.94l.128-.171.406.363a13.914,13.914,0,0,1-1.2,1.521,10.723,10.723,0,0,1-1.5,1.242,2.731,2.731,0,0,1-1.434.409,1.874,1.874,0,0,1-1.135-.537,2.783,2.783,0,0,0-.859-.514l-.192-.044Z",
    transform: "translate(-9.08 -11.437)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1177-2",
    "data-name": "Group 1177",
    transform: "translate(15.33 20.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_631-2",
    "data-name": "Path 631",
    d: "M13.575,14h.061c.165-.206.34-.424.531-.653a5.937,5.937,0,0,1,.633-.656,4.494,4.494,0,0,1,.755.511c.247.218.49.43.737.633.067.11.067.2,0,.267q-.165.266-1.1,1.387a.421.421,0,0,1-.369-.142,1.313,1.313,0,0,0-.264-.206q-.226-.161-.653-.488a.781.781,0,0,0-.511-.186,8.581,8.581,0,0,1-.92,1.184q-.509-.366-1.59-1.019a.205.205,0,0,1,.041-.247A15.751,15.751,0,0,1,11.985,12.9,4.933,4.933,0,0,1,13.575,14Zm.45,4.162-.142-.02a3.936,3.936,0,0,1-.705-.467l-.644-.511c-.081-.081-.113-.136-.1-.165q.37-.448,1.143-1.326c.122-.081.218-.087.287-.02a5.321,5.321,0,0,1,1.347,1,3.91,3.91,0,0,1-.551.766C14.371,17.751,14.162,18,14.025,18.164Z",
    transform: "translate(-10.859 -12.693)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1178-2",
    "data-name": "Group 1178",
    transform: "translate(16.058 13.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_632-2",
    "data-name": "Path 632",
    d: "M11.5,13.762l-.386-.383.128-.174a4.54,4.54,0,0,0,.3-.47,2.218,2.218,0,0,1,.386-.493.72.72,0,0,1,.6-.215,2.1,2.1,0,0,1,.43.075,1.918,1.918,0,0,0,.45.075.52.52,0,0,0,.386-.151,2.533,2.533,0,0,0,.418-.749,2.422,2.422,0,0,1,.374-.705c.142-.029.215.006.215.1a1.322,1.322,0,0,1-.087.493c-.044.128-.078.229-.107.3-.142.342-.293.676-.45,1a2.041,2.041,0,0,1-.792.859,1.228,1.228,0,0,1-.705.02,1.669,1.669,0,0,0-.6-.044.886.886,0,0,0-.406.258Z",
    transform: "translate(-11.11 -10.563)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1179-2",
    "data-name": "Group 1179",
    transform: "translate(19.494 12.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_633-2",
    "data-name": "Path 633",
    d: "M16.662,13.507A8.444,8.444,0,0,1,15.6,16.159a1.3,1.3,0,0,1-.856.612c-.34.081-.688.168-1.042.264q-.387.122-1.184.348c-.122,0-.2-.041-.223-.122,0-.1.087-.2.264-.308.546-.325,1.088-.647,1.634-.961a10.549,10.549,0,0,0,1.532-1.161.888.888,0,0,0,.122-.673.806.806,0,0,0-.287-.409,2.056,2.056,0,0,1-.386.041,1.27,1.27,0,0,1-1.1-.511.992.992,0,0,1-.142-.511,1.921,1.921,0,0,1,.183-.714c.107-.218.212-.444.3-.682s.186-.493.267-.766a1.13,1.13,0,0,1,.592-.592.991.991,0,0,1,1.082.551,3.445,3.445,0,0,1,.447,1.8A4.853,4.853,0,0,1,16.662,13.507Z",
    transform: "translate(-12.294 -9.997)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1180-2",
    "data-name": "Group 1180",
    transform: "translate(24.229 12.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_634-2",
    "data-name": "Path 634",
    d: "M15.355,16.824c-.247.041-.647.11-1.2.206-.122,0-.2-.044-.223-.125-.015-.122.073-.238.264-.345.531-.328,1.053-.653,1.573-.981a11.818,11.818,0,0,0,1.489-1.1A7.016,7.016,0,0,0,18.376,12.5l.775-2.2c.026-.11.116-.165.264-.165a.179.179,0,0,1,.206.165,8.016,8.016,0,0,1-.348,1.776,15.564,15.564,0,0,1-1.509,3.9,1.453,1.453,0,0,1-1.082.673C16.231,16.7,15.79,16.757,15.355,16.824Z",
    transform: "translate(-13.925 -10.129)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4435",
    "data-name": "Group 4435",
    transform: "translate(250.496 456.929) rotate(-14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3351-3",
    "data-name": "Group 3351",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1181-3",
    "data-name": "Group 1181",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_625-3",
    "data-name": "Path 625",
    d: "M37.676,22.3A15.985,15.985,0,1,1,5.7,22.3c0-8.828,7.558-15.924,16.386-15.924A15.6,15.6,0,0,1,37.676,22.3Z",
    transform: "translate(-5.378 -4.893)",
    fill: "#009245"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_120-3",
    "data-name": "Ellipse 120",
    cx: 16.209,
    cy: 15.986,
    rx: 16.209,
    ry: 15.986,
    transform: "translate(0 0.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_121-3",
    "data-name": "Ellipse 121",
    cx: 15.986,
    cy: 15.986,
    rx: 15.986,
    ry: 15.986,
    transform: "translate(0.089)",
    fill: "#9fd647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626-3",
    "data-name": "Path 626",
    d: "M26.163,7.515A13.589,13.589,0,1,1,7.33,26.348,13.672,13.672,0,1,0,26.163,7.515Z",
    transform: "translate(-2.861 -3.134)",
    fill: "#009245"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627-3",
    "data-name": "Path 627",
    d: "M6.6,20.8A14.127,14.127,0,0,1,19.709,6.708,13.672,13.672,0,0,0,6.52,20.371a13.841,13.841,0,0,0,.255,2.638A14.4,14.4,0,0,1,6.6,20.8Z",
    transform: "translate(-4.116 -4.384)",
    fill: "#009245"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1173-3",
    "data-name": "Group 1173",
    transform: "translate(15.124 10.547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1172-3",
    "data-name": "Group 1172"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1689-3",
    "data-name": "Rectangle 1689",
    width: 10.179,
    height: 4.8,
    fill: "#9fd647"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1174-3",
    "data-name": "Group 1174",
    transform: "translate(6.618 14.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_628-3",
    "data-name": "Path 628",
    d: "M10.73,13.334a.866.866,0,0,0-.242-.038,3.261,3.261,0,0,0-2.108,1.262c-.089.061-.158.031-.206-.094v-.133a8.641,8.641,0,0,1,1.41-1.881,7.233,7.233,0,0,1,1.147-.828Z",
    transform: "translate(-8.173 -11.621)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1175-3",
    "data-name": "Group 1175",
    transform: "translate(8.571 19.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_629-3",
    "data-name": "Path 629",
    d: "M11.325,14.677h.054c.145-.178.3-.37.466-.574a5.358,5.358,0,0,1,.556-.574,3.8,3.8,0,0,1,.663.449c.217.191.431.377.647.556.059.1.059.173,0,.235-.1.153-.421.561-.969,1.218a.369.369,0,0,1-.324-.125,1.057,1.057,0,0,0-.232-.181c-.133-.094-.324-.24-.574-.428a.686.686,0,0,0-.449-.163,7.537,7.537,0,0,1-.808,1.04q-.447-.321-1.4-.9A.177.177,0,0,1,9,15.019a13.835,13.835,0,0,1,.933-1.308A4.292,4.292,0,0,1,11.325,14.677Z",
    transform: "translate(-8.939 -13.53)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1176-3",
    "data-name": "Group 1176",
    transform: "translate(8.93 14.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_630-3",
    "data-name": "Path 630",
    d: "M9.08,12.056l.245-.15a3.947,3.947,0,0,1,.885-.357,1.5,1.5,0,0,1,1.374.4,2.032,2.032,0,0,0,1.035.469,2.269,2.269,0,0,0,1.619-.826l.112-.15.357.319a12.222,12.222,0,0,1-1.053,1.336,9.418,9.418,0,0,1-1.318,1.091,2.4,2.4,0,0,1-1.259.359,1.646,1.646,0,0,1-1-.472,2.445,2.445,0,0,0-.755-.451l-.168-.038Z",
    transform: "translate(-9.08 -11.437)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1177-3",
    "data-name": "Group 1177",
    transform: "translate(13.465 17.581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_631-3",
    "data-name": "Path 631",
    d: "M13.245,13.843H13.3c.145-.181.3-.372.466-.574a5.214,5.214,0,0,1,.556-.576,3.948,3.948,0,0,1,.663.449c.217.191.431.377.647.556.059.1.059.173,0,.235q-.145.233-.969,1.218a.369.369,0,0,1-.324-.125,1.153,1.153,0,0,0-.232-.181q-.2-.141-.574-.428a.686.686,0,0,0-.449-.163,7.537,7.537,0,0,1-.808,1.04q-.447-.321-1.4-.895a.18.18,0,0,1,.036-.217,13.835,13.835,0,0,1,.933-1.308A4.333,4.333,0,0,1,13.245,13.843Zm.4,3.655-.125-.018a3.457,3.457,0,0,1-.619-.41l-.566-.449c-.071-.071-.1-.12-.089-.145q.325-.394,1-1.165c.107-.071.191-.076.252-.018a4.674,4.674,0,0,1,1.183.879,3.434,3.434,0,0,1-.484.673C13.943,17.136,13.76,17.355,13.64,17.5Z",
    transform: "translate(-10.859 -12.693)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1178-3",
    "data-name": "Group 1178",
    transform: "translate(14.105 12.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_632-3",
    "data-name": "Path 632",
    d: "M11.449,13.373l-.339-.336.112-.153a3.988,3.988,0,0,0,.265-.413,1.949,1.949,0,0,1,.339-.433.633.633,0,0,1,.525-.189,1.843,1.843,0,0,1,.377.066,1.684,1.684,0,0,0,.4.066.457.457,0,0,0,.339-.133,2.225,2.225,0,0,0,.367-.658,2.127,2.127,0,0,1,.329-.619c.125-.025.189.005.189.092a1.161,1.161,0,0,1-.076.433c-.038.112-.069.2-.094.265-.125.3-.257.594-.4.882a1.793,1.793,0,0,1-.7.755,1.078,1.078,0,0,1-.619.018,1.466,1.466,0,0,0-.528-.038.778.778,0,0,0-.357.227Z",
    transform: "translate(-11.11 -10.563)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1179-3",
    "data-name": "Group 1179",
    transform: "translate(17.123 10.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_633-3",
    "data-name": "Path 633",
    d: "M16.13,13.08a7.417,7.417,0,0,1-.933,2.33,1.137,1.137,0,0,1-.752.538c-.3.071-.6.148-.915.232q-.34.107-1.04.306c-.107,0-.173-.036-.2-.107,0-.084.076-.173.232-.27.479-.286.956-.568,1.435-.844a9.266,9.266,0,0,0,1.346-1.02.78.78,0,0,0,.107-.591.708.708,0,0,0-.252-.359,1.805,1.805,0,0,1-.339.036,1.116,1.116,0,0,1-.969-.449.872.872,0,0,1-.125-.449,1.687,1.687,0,0,1,.161-.627c.094-.191.186-.39.268-.6s.163-.433.235-.673a.993.993,0,0,1,.52-.52.87.87,0,0,1,.951.484,3.026,3.026,0,0,1,.393,1.578A4.263,4.263,0,0,1,16.13,13.08Z",
    transform: "translate(-12.294 -9.997)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1180-3",
    "data-name": "Group 1180",
    transform: "translate(21.282 11.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_634-3",
    "data-name": "Path 634",
    d: "M15.181,16.01c-.217.036-.568.1-1.058.181-.107,0-.173-.038-.2-.11-.013-.107.064-.209.232-.3.466-.288.925-.574,1.382-.862a10.381,10.381,0,0,0,1.308-.969,6.163,6.163,0,0,0,.986-1.738l.681-1.935c.023-.1.1-.145.232-.145a.157.157,0,0,1,.181.145,7.041,7.041,0,0,1-.306,1.56A13.671,13.671,0,0,1,17.3,15.258a1.276,1.276,0,0,1-.951.591C15.951,15.9,15.563,15.951,15.181,16.01Z",
    transform: "translate(-13.925 -10.129)",
    fill: "#fff"
  })))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWaiting, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/waiting.3ff840ba.svg";
export { ForwardRef as ReactComponent };